import React from 'react';

/**
 * Topbar 的頁面標題區塊。
 *
 * Figma v2（DCK-01-02 header `2128:23479`）把返回箭頭與標題放成同一個群組：
 * `bx-arrow-back` 24px + gap 10 + 標題 20px Bold。所以返回鍵屬於這裡，
 * 內容區不再另外畫一列「← 返回列表」。
 *
 * `onBack` 沒給就只顯示標題（列表頁的樣子），模板既有頁面照舊不受影響。
 */
const BreadCrumb = ({ breadCrumbItems, onBack }) => {
    return (
        <React.Fragment>
            <div className="d-none d-sm-flex align-items-center ms-3 align-self-center" style={{ gap: 10 }}>
                {onBack ? (
                    <button
                        type="button"
                        aria-label="返回"
                        onClick={onBack}
                        className="btn p-0 border-0 bg-transparent d-inline-flex align-items-center text-body"
                    >
                        <i className="bx bx-arrow-back" style={{ fontSize: 24, display: "block" }} />
                    </button>
                ) : null}
                <h4 className="page-title mb-0">{breadCrumbItems.title}</h4>
            </div>
        </React.Fragment>
    );
};

export default BreadCrumb;
